// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul[data-v-b614b94c]{list-style-type:disc;padding-left:calc(var(--default-grid-baseline)*3)}`, "",{"version":3,"sources":["webpack://./src/shared/components/ncTable/partials/TableCellMultiSelection.vue"],"names":[],"mappings":"AAEA,oBACC,oBAAA,CACA,iDAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
